import { gql } from 'graphql-request';

import {
  TeamID,
  TeamName,
  TeamNanoID,
  TeamUserID,
  TeamUserNanoID,
  TeamUserUUID,
  TeamUUID
} from '../teamsTypes';

export interface FetchTeamUsersQueryResponse {
  id: TeamID;
  uuid: TeamUUID;
  nanoId: TeamNanoID;
  name: TeamName;
  users: {
    id: TeamUserID;
    uuid: TeamUserUUID;
    nanoId: TeamUserNanoID;
  }[];
}

export const FETCH_TEAM_USERS_QUERY = gql`
  query TeamUsers($uuid: ID!) {
    team(uuid: $uuid) {
      id
      uuid
      nanoId
      name
      users {
        id
        uuid
        nanoId
      }
    }
  }
`;
